// extracted by mini-css-extract-plugin
module.exports = {"helsinkiCityOwnedText":"eventName_helsinkiCityOwnedText__bpeRT","eventCancelled":"eventName_eventCancelled__ElSFx"};